import script from "./EditExpense.vue?vue&type=script&setup=true&lang=js"
export * from "./EditExpense.vue?vue&type=script&setup=true&lang=js"

import "./EditExpense.vue?vue&type=style&index=0&id=38c4c874&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c4c874"]])

export default __exports__